export default "__VITE_ASSET__DL79aYDL__"